(function () {
  if (window.ThemeMotion) return;

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;

  var ignoredSectionSelectors = [
    '.site-header',
    '.site-footer',
    '.announcement-bar',
    '.promo-popup',
  ];

  var shouldIgnoreSection = function (section) {
    return ignoredSectionSelectors.some(function (selector) {
      return section.querySelector(selector);
    });
  };

  var isInitiallyVisible = function (element) {
    var rect = element.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;

    return rect.top < viewportHeight * 0.9;
  };

  var initReveals = function () {
    var sections = Array.prototype.slice.call(document.querySelectorAll('.shopify-section'))
      .filter(function (section) {
        return !shouldIgnoreSection(section);
      });

    if (!sections.length) return;

    if (reducedMotion || !('IntersectionObserver' in window)) {
      sections.forEach(function (section) {
        section.dataset.motionVisible = 'true';
      });
      return;
    }

    sections.forEach(function (section, index) {
      section.dataset.motionReveal = 'true';
      section.style.setProperty('--theme-motion-delay', Math.min(index * 18, 90) + 'ms');

      if (isInitiallyVisible(section)) {
        section.dataset.motionVisible = 'true';
      }
    });

    root.classList.add('motion-ready');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;

        entry.target.dataset.motionVisible = 'true';
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -12% 0px',
      threshold: 0.12,
    });

    sections.forEach(function (section) {
      if (section.dataset.motionVisible === 'true') return;
      observer.observe(section);
    });
  };

  var init = function () {
    if (reducedMotion) {
      root.classList.add('motion-reduced');
    }

    initReveals();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  window.ThemeMotion = {
    refresh: initReveals,
  };
})();
